<template>
  <el-container class="box">
    <el-header>
      <router-link class="logo-box" to="/">
        <img src="../assets/images/layout/logo.png" alt="">
        <img src="../assets/images/layout/developer-logo.png" alt="">
      </router-link>
      <div :class="{ 'fixed-header': fixedHeader }" class="headerRight">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
    </el-header>
    <el-container class="main">
      <el-aside
        v-show="!this.$route.meta.hiddenAside"
        :width="!isCollapse ? '210px' : '50px'"
      >
        <div
          v-if="device === 'mobile' && sidebar.opened"
          class="drawer-bg"
          @click="handleClickOutside"
        />
        <sidebar class="sidebar-container" :user-routes="userRoutes" />
      </el-aside>
      <el-main>
        <div :class="{ hasTagsView: needTagsView }" class="main-container">
          <app-main />
          <right-panel v-if="showSettings">
            <settings />
          </right-panel>
        </div>
      </el-main>
    </el-container>
  </el-container>
  <!-- <div :class="classObj"
       class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened"
         class="drawer-bg"
         @click="handleClickOutside" />
    <sidebar class="sidebar-container" />
    <div :class="{hasTagsView:needTagsView}"
         class="main-container">
      <app-main />
    </div>
  </div> -->
</template>

<script>
import RightPanel from '@/components/RightPanel'
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'

export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    RightPanel,
    Settings,
    Sidebar,
    TagsView
  },
  mixins: [ResizeMixin],
  data() {
    return {
      userRoutes: []
    }
  },
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      showSettings: (state) => state.settings.showSettings,
      needTagsView: (state) => state.settings.tagsView,
      fixedHeader: (state) => state.settings.fixedHeader,
      roles: (state) => state.account.user.roles
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    isDeveloper() {
      return this.roles && this.roles.includes('developer_tenant')
    }
  },
  created() {
    this.userRoutes = this.$store.state.account.routes
  },

  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.path.includes('app-management') && vm.isDeveloper) {
        vm.userRoutes = vm.$store.state.account.routes.filter(item => item.path.includes('app-management') === true)
      } else if (vm.isDeveloper) {
        if (to.path.includes('token-manager') || to.path.includes('security-manager')) {
          vm.userRoutes = vm.$store.state.account.routes.filter(
            item => item.path.includes('token-manager') === true ||
              item.path.includes('security-manager') === true)
        } else {
          vm.userRoutes = vm.$store.state.account.routes.filter(
            item => item.path.includes('app-management') === false &&
              !item.path.includes('token-manager') &&
              !item.path.includes('security-manager'))
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
.box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.main {
  width: 100%;
  height: calc(100% - 60px);
}
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #fff;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
.headerRight {
  width: 89.5%;
}
.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
::v-deep .el-aside {
  box-sizing: border-box;
  background-color: #fff;
}
.sidebar-container {
  width: 100% !important;
}
.el-header {
  display: flex;
  background-color: #3569fd;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  position: relative;
  .logo-box {
    width: 180px;
    height: 100%;
    display: flex;
    align-items: center;
    img:first-child {
      width: 35px;
      margin-right: 10px;
    }
    img:last-child {
      width: 124px;
    }
  }
  .menuClass {
    position: absolute;
    right: 250px;
    z-index: 2000;
  }
  /deep/ li.el-menu-item.is-active {
    background-color: #3750c2 !important;
    border-bottom: 0;
  }
  /deep/ ul.menuClass.el-menu--horizontal.el-menu {
    border-bottom: 0;
  }
  .el-menu--horizontal > .el-menu-item {
    border-bottom: 0;
  }
  .home {
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }
}
.el-main {
  background-color: #f5f7fa;
  height: 100%;
  overflow: scroll;
}
.el-aside {
  height: 100%;
  padding: 0;
  box-sizing: border-box;
}
</style>
